import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { MARKET_TABS, STATUS_OPTS } from "./MarketLeasing";

const inp = "w-full rounded border border-border bg-secondary/30 px-2 py-1 text-xs outline-none focus:border-primary";

export function MarketEditor({ market = {}, onChange }) {
  const [tab, setTab] = useState("overview");
  const t = MARKET_TABS.find((x) => x.key === tab);
  const td = market[tab] || {};
  const setTd = (patch) => onChange({ ...market, [tab]: { ...td, ...patch } });
  const setRows = (key, rows) => setTd({ [key]: rows });
  return (
    <div className="space-y-3 border-t border-border pt-4" data-testid="mk-editor">
      <div className="text-xs font-semibold">Market &amp; Leasing data</div>
      <div className="flex flex-wrap gap-1">
        {MARKET_TABS.map((x) => (
          <button key={x.key} onClick={() => setTab(x.key)} data-testid={`mk-edit-tab-${x.key}`}
            className={`rounded-full border px-2.5 py-1 text-[11px] ${tab === x.key ? "border-primary bg-primary/15 text-primary" : "border-border text-muted-foreground"}`}>
            {x.label}{Object.values(market[x.key] || {}).some((v) => Array.isArray(v) && v.length) ? " •" : ""}
          </button>
        ))}
      </div>
      <div className="space-y-1"><label className="text-[10px] uppercase tracking-wide text-muted-foreground">Tab note</label>
        <textarea rows={2} value={td.note || ""} onChange={(e) => setTd({ note: e.target.value })} className={inp} data-testid={`mk-edit-note-${tab}`} /></div>
      {t.blocks.map((b) => {
        const rows = td[b.key] || [];
        return (
          <div key={b.key} className="space-y-2" data-testid={`mk-edit-block-${tab}-${b.key}`}>
            <div className="flex items-center justify-between"><span className="text-[11px] font-medium">{b.title} <span className="text-muted-foreground">({rows.length})</span></span>
              <button onClick={() => setRows(b.key, [...rows, {}])} className="flex items-center gap-1 text-[11px] text-primary" data-testid={`mk-add-row-${tab}-${b.key}`}><Plus className="h-3 w-3" />Add row</button></div>
            {rows.map((r, i) => (
              <div key={i} className="rounded-md border border-border p-2 space-y-1.5 bg-card" data-testid={`mk-row-${tab}-${b.key}-${i}`}>
                <div className="grid grid-cols-2 gap-1.5">
                  {b.cols.map(([k, label, type]) => (
                    <div key={k} className="space-y-0.5"><div className="text-[9px] uppercase tracking-wide text-muted-foreground truncate">{label}</div>
                      {type === "status"
                        ? <select value={r[k] || ""} onChange={(e) => setRows(b.key, rows.map((x, j) => (j === i ? { ...x, [k]: e.target.value } : x)))} className={inp} data-testid={`mk-input-${tab}-${b.key}-${i}-${k}`}><option value="">—</option>{STATUS_OPTS.map((o) => <option key={o}>{o}</option>)}</select>
                        : <input value={r[k] ?? ""} onChange={(e) => setRows(b.key, rows.map((x, j) => (j === i ? { ...x, [k]: e.target.value } : x)))} className={inp} data-testid={`mk-input-${tab}-${b.key}-${i}-${k}`} />}
                    </div>
                  ))}
                </div>
                <button onClick={() => setRows(b.key, rows.filter((_, j) => j !== i))} className="flex items-center gap-1 text-[10px] text-muted-foreground hover:text-destructive" data-testid={`mk-remove-row-${tab}-${b.key}-${i}`}><Trash2 className="h-3 w-3" />Remove</button>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
